export enum ELengthValueType
{
    Millimeter,
    Centimeter,
    Meter
}